import { motion } from "framer-motion";
import videoSource from "../../assets/ad-video2.mp4";

const HeroSection = () => {
  return (
    <section id="home" className="relative overflow-hidden bg-slate-950">
      <div className="absolute inset-0">
        <video autoPlay muted loop playsInline className="h-full w-full object-cover opacity-40">
          <source src={videoSource} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-slate-950/80" />
      </div>

      <div className="relative mx-auto flex min-h-[85vh] max-w-7xl flex-col justify-center px-6 py-24 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-8"
        >
          <div className="inline-flex items-center gap-3 rounded-full border border-emerald-300/20 bg-emerald-500/10 px-4 py-2 text-sm uppercase tracking-[0.32em] text-emerald-200">
            Professional Indoor Badminton
          </div>
          <div className="max-w-4xl space-y-6">
            <h1 className="text-5xl font-semibold leading-tight text-white sm:text-6xl lg:text-7xl">
              Play. Train. Improve.
            </h1>
            <p className="max-w-2xl text-lg leading-8 text-slate-300 sm:text-xl">
              Professional Indoor Badminton Court and Coaching in Mangadu.
            </p>
            <div className="grid gap-3 sm:grid-cols-[auto_auto] sm:items-center">
              <div className="rounded-3xl border border-white/10 bg-slate-900/70 px-5 py-4 shadow-[0_28px_80px_rgba(15,23,42,0.18)]">
                <p className="text-sm uppercase tracking-[0.36em] text-slate-400">Regular Play</p>
                <p className="mt-2 text-base font-semibold text-white">Available Daily | 5:00 AM – 11:00 PM</p>
              </div>
              <div className="rounded-3xl border border-white/10 bg-slate-900/70 px-5 py-4 shadow-[0_28px_80px_rgba(15,23,42,0.18)]">
                <p className="text-sm uppercase tracking-[0.36em] text-slate-400">Coaching</p>
                <p className="mt-2 text-base font-semibold text-white">Monday – Saturday | 5:00 PM – 7:00 PM</p>
              </div>
            </div>
            <div className="flex flex-col gap-4 sm:flex-row">
              <a
                href="tel:+919840777003"
                className="btn-primary inline-flex w-full items-center justify-center rounded-full px-7 py-3 text-sm font-semibold uppercase text-slate-950 transition hover:bg-emerald-400 sm:w-auto"
              >
                Book Court
              </a>
              <a href="#programs" className="btn-secondary w-full sm:w-auto">
                View Training Programs
              </a>
            </div>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
            <div className="glass-panel px-6 py-5">
              <p className="text-sm uppercase tracking-[0.3em] text-slate-400">Indoor Court</p>
              <p className="mt-3 text-3xl font-semibold text-white">1</p>
            </div>
            <div className="glass-panel px-6 py-5">
              <p className="text-sm uppercase tracking-[0.3em] text-slate-400">Coaches</p>
              <p className="mt-3 text-3xl font-semibold text-white">2</p>
            </div>
            <div className="glass-panel px-6 py-5">
              <p className="text-sm uppercase tracking-[0.3em] text-slate-400">Open Hours</p>
              <p className="mt-3 text-3xl font-semibold text-white">5:00 AM – 11:00 PM</p>
            </div>
            <div className="glass-panel px-6 py-5">
              <p className="text-sm uppercase tracking-[0.3em] text-slate-400">Coaching</p>
              <p className="mt-3 text-3xl font-semibold text-white">Mon – Sat</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
